module.exports = __webpack_public_path__ + "img/shipo-icon-order-bottom-disable.3e22ed7d.svg";